import React from 'react';
import styled from 'styled-components';
import LeftArrowIcon from '@material-ui/icons/ChevronLeft';
import RightArrowIcon from '@material-ui/icons/ChevronRight';
//
import colors from 'theme/colors';

const { onyx60 } = colors;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
`;

const PaginationButton = styled.button`
  background: none;
  border: none;

  :hover {
    cursor: pointer;
  }
`;

const SelectContainer = styled.div`
  border-bottom: 1px solid ${onyx60};
  padding: 2px 4px 2px 8px;
`;

const PaginationSelect = styled.select`
  border: none;
  background: none;
  width: 40px;
  font-size: 14px;
  color: ${onyx60};
`;

interface IPaginationProps {
  canNextPage: boolean;
  canPreviousPage: boolean;
  gotoPage: (n: number) => void;
  nextPage: () => void;
  pageCount: number;
  pageIndex: number;
  previousPage: () => void;
}

function renderSelectOptions(count: number) {
  const arr = [];
  for (let i = 0; i < count; i++) {
    arr.push(
      <option key={i} value={i}>
        {i + 1}
      </option>
    );
  }
  return <>{arr}</>;
}

export default ({
  canNextPage,
  canPreviousPage,
  gotoPage,
  nextPage,
  pageCount,
  pageIndex,
  previousPage,
}: IPaginationProps) => (
  <Pagination>
    <PaginationButton type="button" onClick={() => previousPage()} disabled={!canPreviousPage}>
      <LeftArrowIcon />
    </PaginationButton>
    <SelectContainer>
      <PaginationSelect
        id="page-selector"
        value={pageIndex}
        onChange={e => {
          gotoPage(e.target.value ? Number(e.target.value) : 0);
        }}
      >
        {renderSelectOptions(pageCount)}
      </PaginationSelect>
    </SelectContainer>
    <PaginationButton type="button" onClick={() => nextPage()} disabled={!canNextPage}>
      <RightArrowIcon />
    </PaginationButton>{' '}
  </Pagination>
);
